import { CALL_API, Schemas } from '../../common/middleware/api';
import globalize from '../../common/services/globalize';
import moment from 'moment';

export const WAITING_LIST_REQUEST = 'WAITING_LIST_REQUEST';
export const WAITING_LIST_SUCCESS = 'WAITING_LIST_SUCCESS';
export const WAITING_LIST_FAILURE = 'WAITING_LIST_FAILURE';

export const WAITING_LIST_FETCH_REQUEST = 'WAITING_FETCH_LIST_REQUEST';
export const WAITING_LIST_FETCH_SUCCESS = 'WAITING_FETCH_LIST_SUCCESS';
export const WAITING_LIST_FETCH_FAILURE = 'WAITING_LIST_FETCH_FAILURE';

export const WAITING_LIST_UPDATE_REQUEST = 'WAITING_LIST_UPDATE_REQUEST';
export const WAITING_LIST_UPDATE_SUCCESS = 'WAITING_LIST_UPDATE_SUCCESS';
export const WAITING_LIST_UPDATE_FAILURE = 'WAITING_LIST_UPDATE_FAILURE';

export const WAITING_LIST_EXPORT_REQUEST = 'WAITING_LIST_EXPORT_REQUEST';
export const WAITING_LIST_EXPORT_SUCCESS = 'WAITING_LIST_EXPORT_SUCCESS';
export const WAITING_LIST_EXPORT_FAILURE = 'WAITING_LIST_EXPORT_FAILURE';

export const loadWaitingList = (options) => ({
	[CALL_API]: {
		types: [WAITING_LIST_REQUEST, WAITING_LIST_SUCCESS, WAITING_LIST_FAILURE],
		endpoint: 'api/waitingList',
		request: options,
		schema: Schemas.WAITING_LIST_ARRAY
	}
});

export const exportWaitingList = (options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [WAITING_LIST_EXPORT_REQUEST, WAITING_LIST_EXPORT_SUCCESS, WAITING_LIST_EXPORT_FAILURE],
			endpoint: `api/waitingList/export`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: 'Excel',
		filename: () => `WaitingList-${moment().format('YYYY-MM-DD')}.xlsx`
	});
}

export const fetchWaitingList = (id) => ({
	[CALL_API]: {
		types: [WAITING_LIST_FETCH_REQUEST, WAITING_LIST_FETCH_SUCCESS, WAITING_LIST_FETCH_FAILURE],
		endpoint: `api/waitingList/${id}`,
		schema: Schemas.WAITING_LIST
	}
});

export const updateWaitingList = (id, waitingList) => ({
	[CALL_API]: {
		types: [WAITING_LIST_UPDATE_REQUEST, WAITING_LIST_UPDATE_SUCCESS, WAITING_LIST_UPDATE_FAILURE],
		endpoint: `api/waitingList/${id}`,
		method: 'PUT',
		request: waitingList,
		schema: Schemas.WAITING_LIST,
		form: 'waitingListDetails'
	}
});